import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IUserTicketState }      from 'Redux/Slices/UserTicket/UserTicketSlice';
import { UserTicket }            from 'Domain/Models';
import { PayloadActionList }    from 'Utils';
import { removeActionTypes }    from 'Utils/ReducerUtility';


export const findUserTicketsRequest = (state: Draft<IUserTicketState>, { type }: PayloadActionList) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.updatedAt = Date.now();
};

export const findUserTicketsSuccess = (state: Draft<IUserTicketState>, { type, payload }: PayloadAction<{
  userTickets: Record<string, UserTicket>,
  maxCount: number,
}>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  state.entries = payload.userTickets;
  state.maxCount = payload.maxCount || state.maxCount;

};

export const findUserTicketsFailure = (state: Draft<IUserTicketState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
